export default "__VITE_ASSET__BWsac$jF__"